import {
  CButton,
  CFormSelect,
  CFormSwitch,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import EmailQuotaService from 'src/service/EmailQuotaService'

const FantasyRoundEmail = (props) => {
  const [visible, setVisible] = useState(false)
  const [testEmail, setTestEmail] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSendTestEmail = () => {
    if (!testEmail) {
      ToastComponent('Please enter an email address', 'error')
      return
    }
    const data = { testEmail }
    setLoading(true)
    EmailQuotaService.testFantasyRoundReminderBeforeRoundStart(data).then((res) => {
      setLoading(false)
      ToastComponent(res.message, res.success ? 'success' : 'error')
      if (res.success) {
        setVisible(false)
        setTestEmail('')
      }
    })
  }

  const [confirmVisible, setConfirmVisible] = useState(false)
  const [pendingValue, setPendingValue] = useState('')

  const changeNotificationHour = (e) => {
    const selectedValue = e.target.value
    setPendingValue(selectedValue)
    setConfirmType('hour')
    setConfirmVisible(true)
  }
  const confirmChange = () => {
    if (confirmType === 'hour') {
      // Update UI for hour
      props.handleHourChange({ target: { value: pendingValue } }, '48')

      const durationObj = {}
      durationObj[48] = pendingValue

      // ✅ Auto-disable if hour is 0 or empty
      if (!pendingValue || pendingValue === '0') {
        // Turn OFF switch
        props.handleEnableDisableChangeStatus({ target: { checked: false } }, '48')

        // Save both hour + disable
        props.handleSaveEmailNotificationSettingUpdated(48, durationObj)
        setConfirmVisible(false)
        return
      }

      // Normal save
      props.handleSaveEmailNotificationSettingUpdated(48, durationObj)
    }

    if (confirmType === 'switch') {
      // Update UI toggle
      props.handleEnableDisableChangeStatus({ target: { checked: pendingSwitchValue } }, '48')

      // Save using latest hour value
      const durationObj = {}
      durationObj[48] = props.hourValue['48']

      props.handleSaveEmailNotificationSettingUpdated(48, durationObj)
    }

    setConfirmVisible(false)
  }

  // On save on change of status
  const [confirmType, setConfirmType] = useState(null) // 'hour' or 'switch'
  const [pendingSwitchValue, setPendingSwitchValue] = useState(null)
  const changeNotificationSwitch = (e) => {
    const newValue = e.target.checked // true = enable, false = disable

    // If attempting to enable when duration is not set > 0
    if (newValue === true && (!props.hourValue['48'] || props.hourValue['48'] === '0')) {
      ToastComponent('Please set a notification time before enabling this reminder.', 'error')
      return
    }

    setPendingSwitchValue(newValue)
    setConfirmType('switch')
    setConfirmVisible(true)
  }
  // finish here

  return (
    <>
      <table className="main-table table innertable">
        <thead>
          <tr>
            <th width="30%">Name</th>
            <th width="30%">Duration</th>
            <th width="20%">Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Fantasy Round Reminder</td>
            <td>
              <CFormSelect
                aria-label="Select Structure"
                name="templete_id_48"
                className="form-control"
                value={props.hourValue['48']}
                onChange={changeNotificationHour} // now opens confirm dialog
              >
                <option value="">Set Hours (Before Round Starts)</option>
                {[...Array(24).keys()].map((num) => (
                  <option key={num + 1} value={num + 1}>
                    {num + 1}
                  </option>
                ))}
              </CFormSelect>
            </td>
            <td>
              <CFormSwitch
                size="lg"
                label={props.enableDisableStatus['48'] ? 'Enabled' : 'Disabled'}
                id="formSwitchCheckDefaultLg"
                checked={props.enableDisableStatus['48'] || false}
                onChange={changeNotificationSwitch}
              />
            </td>
            <td className="d-flex gap-2">
              <CButton color="info" onClick={() => setVisible(true)}>
                Test Email
              </CButton>
            </td>
          </tr>
        </tbody>
      </table>

      {/* --- Modal for Sending Test Email --- */}
      <CModal visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Send Test Email</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CFormInput
            type="email"
            placeholder="Enter test email address"
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
          />
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSendTestEmail} disabled={loading}>
            {loading ? 'Sending...' : 'Send'}
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal visible={confirmVisible} onClose={() => setConfirmVisible(false)}>
        <CModalHeader>
          <CModalTitle>Confirm Change</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {confirmType === 'hour' && (
            <>
              Are you sure you want to change the reminder to <strong>{pendingValue}</strong>{' '}
              hour(s)?
            </>
          )}

          {confirmType === 'switch' && (
            <>
              Are you sure you want to {pendingSwitchValue ? 'Enable' : 'Disable'} this
              notification?
            </>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setConfirmVisible(false)}>
            Cancel
          </CButton>
          <CButton color="primary" onClick={confirmChange}>
            Confirm
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default FantasyRoundEmail
